export class ZoomOptionModel{
    public zoomLevels = [2, 1.5, 1, 0.75, 0.5];
}